
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getRemovePermissionDtoFormGroup() {
return new FormGroup({
    permissionId: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      